<script>
export default {

    name: 'publish-modal',

    props:
    {
        items: Array,
        type: String,
    },

    computed:
    {
        ids()
        {
            let array = []
            if (this.items) {
                for (let i = 0; i < this.items.length; i++) {
                    array.push(this.items[i].id)
                }
                return array
            }
        },

        valid()
        {
            let valid = true
            if (this.items && this.items.length > 0)
            {
                for (let i = 0; i < this.items.length; ++i) 
                {
                    valid = valid && this.items[i].is_valid
                }
                return valid
            } else {
                return false
            }
        }
    },


    methods: {
        openModal()
        {
            this.$refs.publishModal.open()
        },
        cancel()
        {
            this.$refs.publishModal.close()
        },
        publish()
        {
            this.$store.dispatch(this.type, {ids: this.ids,action: 'publish',}).then( res=>{
                this.$emit('fetch')
                this.cancel()
            })
        },

        edit()
        {
            for (let i = 0; i < this.items.length; ++i) 
            {
                if (!this.items[i].is_valid)
                {
                    if(this.type == 'stackedOfferAction')
                    {
                        this.$router.push({
                            name: 'stacked-offer-edit',
                            params: {
                                slug: 'creative',
                                item: this.items[i].id
                            }
                        })
                    } else if(this.type == 'offerAction') {
                        this.$router.push({
                            name: 'offer-edit',
                            params: {
                                slug: 'creative',
                                item: this.items[i].id
                            }
                        })
                    } else if(this.type == 'landingPageAction') {
                        this.$router.push({
                            name: 'landing-page-edit',
                            params: {
                                slug: 'creative',
                                item: this.items[i].id
                            }
                        })
                    }

                }
            }
        },
    }

}
</script>

<template lang="html">
    <custom-modal :exitIcon=" valid ?  'fal fa-play-circle' : 'fas fa-exclamation-triangle'" ref="publishModal">
        <div slot="button">
            <custom-button 
                v-if="valid"
                classes="green text-white" 
                iconBeforeText="fal fa-play-circle fa-xs mr-2" 
                text="Publish" 
                @buttonClick="openModal"></custom-button>

            <custom-button 
                v-else
                classes="green text-white" 
                iconBeforeText="fas fa-exclamation-triangle"
                text="Publish" 
                @buttonClick="openModal"></custom-button>
        </div>
        <div slot="header" class="">
            <p class="text-lg font-weight-semibold">
                Publish item
            </p>
            <template v-if="items && items.length > 0">
                <div v-for="item in items">
                    <h2 class="font-weight-bold mb-0">
                        {{ item.name }}
                    </h2>
                    <p class="text-desc-color" v-if="item.client">
                        {{ item.client.name }}
                    </p>
                </div>
            </template>
            <template v-else>
                <h2 class="font-weight-bold mb-0">
                    There are no selected items
                </h2>
            </template>
        </div>
        <div v-if="valid">
            <p class="text-lg font-weight-bold">Item goes live based on the following settings:</p>
            <ul class="font-awesomed-list pro calendar green m-0">
                <li v-for="item in items">
                    Starts from
                    <template v-if="item.scheduled_from">
                        {{ $moment(item.scheduled_from).format('D MMM YYYY') }}
                    </template>
                    <template v-else>
                        No Start date given
                    </template>
                    <br>
                    Expires at
                    <template v-if="item.scheduled_to">
                        {{ $moment(item.scheduled_to).format('D MMM YYYY') }}
                    </template>
                    <template v-else>
                        No end date give
                    </template>
                </li>
            </ul>
        </div>
        <div v-else>
            <div v-if="items && items.length > 0">
                <p class="text-lg font-weight-bold">
                    <span class="text-red">
                        <i class="fas fa-exclamation-triangle"></i>
                    </span>
                    Item cannot published due to errors!
                </p>
            </div>
        </div>
        <div slot="footer" class="">
            <custom-button classes="white w-120" text="Cancel" @buttonClick="cancel"></custom-button>
            <custom-button v-if="valid" :disabled="!items || items.length==0" classes="green text-white w-120" text="Publish" @buttonClick="publish"></custom-button>
            <custom-button v-if="!valid && items && items.length > 0" classes="blue text-white w-120" text="Complete" @buttonClick="edit"></custom-button>
        </div>

    </custom-modal>
</template>



// WEBPACK FOOTER //
// src/components/elements/modals/publish.vue